import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from './../../environments/environment';


@Injectable()
export class BookService {

    svc_rest = environment.restUrl;

    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    constructor(public http:HttpClient) {
    }

    
    getPublicBookingData(): Observable<any> {console.log(this.svc_rest);
        return this.http.get<any>(this.svc_rest + '/pb/getAddPublicBookingData', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }


    getQuoteById(id): Observable<any> {
        return this.http.get<any>(this.svc_rest + '/pb/getQuoteById/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }


    getQuoteByClientReference(quote_reference): Observable<any> {
        return this.http.get<any>(this.svc_rest + '/pb/getQuoteByClientReference/' + quote_reference,  this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }


    createQuote(quote): Observable<any> {
        return this.http.post<any>(this.svc_rest + '/pb/createQuote', quote,  this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }


    updateQuote(quote): Observable<any> {
        return this.http.post<any>(this.svc_rest + '/pb/updateQuote', quote,  this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    getQuoteRates(quote): Observable<any> {
        return this.http.post<any>(this.svc_rest + '/pb/getQuoteRates' , quote,  this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    savePublicBooking(booking): Observable<any> {	
    	return this.http.post(this.svc_rest + '/pb/savePublicBooking', booking , this.httpOptions)
            .pipe(
                catchError(this.handleError)
            )    
    }

    getLocationRecord(latitude, longtitude): any {
        var coordinates = {lat:latitude, lng:longtitude};
        return this.http.post<any>(this.svc_rest + '/tms/getLocationRecord', coordinates, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    getBookingRates(booking): Observable<any> {
        return this.http.post<any>(this.svc_rest + '/pb/getBookingRates' , booking,  this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    checkBookingExists(params: any): Observable<any> {
        return this.http.post<any>(this.svc_rest + '/pb/checkBookingExists', params, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }


    private extractData(res: Response) {
    	let body = res.json();
    	console.log(body);
	    if(body)
            return body || {};
        else
            return null;
    }

    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }


}